export const environment = {
  production: false,
  environmentName: 'Dev',
  googleTagManagerKey: 'GTM-54V22Q5',
  cdn: 'https://pdpdevelopment.blob.core.windows.net/roadrunner-cdn',
  appInsights: {
    instrumentationKey: 'd17a1f48-dbeb-4dce-ab33-2846e9742a2b',
  },
};
